import { createAction, props } from "@ngrx/store";
import {
  RoomStageLayoutFocusDeleteCmd,
  RoomStageLayoutFocusSetCmd,
  RoomStageLayoutMainDeleteCmd,
  RoomStageLayoutMainSetCmd,
  RoomStageLayoutUpdateVO
} from "@youm-front/room/domain";
import { RoomStageLayoutState } from "../reducers";

export const roomStageLayoutFocusDelete = createAction(
  "[Room] Room Stage Layout Focus Delete",
  props<{
    roomStageLayoutState: RoomStageLayoutState;
    roomStageLayoutFocusDeleteCmd: RoomStageLayoutFocusDeleteCmd;
  }>()
);
export const roomStageLayoutFocusDeleteSuccess = createAction(
  "[Room] Room Stage Layout Focus Delete Success",
  props<{ roomStageLayoutFocusDeleteCmd: RoomStageLayoutFocusDeleteCmd }>()
);
export const roomStageLayoutFocusDeleteFailure = createAction(
  "[Room] Room Stage Layout Focus Delete Failure",
  props<{
    error: string;
    roomStageLayoutState: RoomStageLayoutState;
  }>()
);

export const roomStageLayoutFocusSet = createAction(
  "[Room] Room Stage Layout Focus Set",
  props<{
    roomStageLayoutState: RoomStageLayoutState;
    roomStageLayoutFocusSetCmd: RoomStageLayoutFocusSetCmd;
  }>()
);
export const roomStageLayoutFocusSetSuccess = createAction(
  "[Room] Room Stage Layout Focus Set Success",
  props<{
    roomStageLayoutState: RoomStageLayoutState;
    roomStageLayoutFocusSetCmd?: RoomStageLayoutFocusSetCmd;
  }>()
);
export const roomStageLayoutFocusSetFailure = createAction(
  "[Room] Room Stage Layout Focus Set Failure",
  props<{
    roomStageLayoutState: RoomStageLayoutState;
    error: string;
  }>()
);

export const roomStageLayoutMainDelete = createAction(
  "[Room] Room Stage Layout Main Delete",
  props<{
    roomStageLayoutState: RoomStageLayoutState;
    roomStageLayoutMainDeleteCmd: RoomStageLayoutMainDeleteCmd;
  }>()
);
export const roomStageLayoutMainDeleteSuccess = createAction(
  "[Room] Room Stage Layout Main Delete Success",
  props<{ roomStageLayoutMainDeleteCmd: RoomStageLayoutMainDeleteCmd }>()
);
export const roomStageLayoutMainDeleteFailure = createAction(
  "[Room] Room Stage Layout Main Delete Failure",
  props<{
    error: string;
    roomStageLayoutState: RoomStageLayoutState;
  }>()
);

export const roomStageLayoutMainSet = createAction(
  "[Room] Room Stage Layout Main Set",
  props<{
    roomStageLayoutState: RoomStageLayoutState;
    roomStageLayoutMainSetCmd: RoomStageLayoutMainSetCmd;
  }>()
);
export const roomStageLayoutMainSetSuccess = createAction(
  "[Room] Room Stage Layout Main Set Success",
  props<{
    roomStageLayoutState: RoomStageLayoutState;
    roomStageLayoutMainSetCmd?: RoomStageLayoutMainSetCmd;
  }>()
);
export const roomStageLayoutMainSetFailure = createAction(
  "[Room] Room Stage Layout Main Set Failure",
  props<{
    roomStageLayoutState: RoomStageLayoutState;
    error: string;
  }>()
);

export const roomStageLayoutUpdate = createAction(
  "[Room] Room Stage Layout Update",
  props<{
    roomStageLayoutState: RoomStageLayoutState;
    roomStageLayoutUpdateVO: RoomStageLayoutUpdateVO;
  }>()
);
export const roomStageLayoutUpdateSuccess = createAction(
  "[Room] Room Stage Layout Update Success",
  props<{ roomStageLayoutUpdateVO: RoomStageLayoutUpdateVO }>()
);
export const roomStageLayoutUpdateFailure = createAction(
  "[Room] Room Stage Layout Update Failure",
  props<{
    roomStageLayoutState: RoomStageLayoutState;
    error: string;
  }>()
);
